import { first_value } from '@/services/onboarding_form_helpers';

export function get_entity_type_option_id(entity_type = {}) {
  return Number(first_value([
    entity_type?.id,
    entity_type?.entity_type_id
  ], 0));
}

export function get_entity_type_option_name(entity_type = {}) {
  return first_value([
    entity_type?.name,
    entity_type?.entity_type_name,
    entity_type?.source_name
  ], 'Onboarding');
}

export function find_case_for_entity_type(cases = [], entity_type_id = 0) {
  const resolved_entity_type_id = Number(entity_type_id || 0);
  if (resolved_entity_type_id <= 0) return null;

  return cases.find((case_item) => (
    Number(case_item?.entity_type_id || case_item?.threshold_entity_type_id_used || 0) === resolved_entity_type_id
  )) || null;
}

export function build_onboarding_creation_options(entity_type_id) {
  const options = {
    entity_type_id: Number(entity_type_id)
  };
  return options;
}

export function build_onboarding_metadata_payload({
  creation_response,
  selected_entity_type
} = {}) {
  const payload = {
    creation_response,
    onboarding_form: {},
    selected_project: {},
    selected_entity_type,
    selected_roles: [],
    selected_templates: []
  };
  return payload;
}
